import { useQuery } from "@tanstack/react-query";
import { axiosGet } from "../services/axiosService"; // fixed import path

const fetchUserDetails = async () => {
  const {
    data: { data },
  } = await axiosGet("/users/findUser");
  return data;
};

export function useUserDetails(options = {}) {
  return useQuery({
    queryKey: ["userDetails"],
    queryFn: fetchUserDetails,
    staleTime: 5 * 60 * 1000, // 5 minutes
    ...options,
  });
}
